@file:OptIn(InternalResourceApi::class)

package mobile_wallet.feature.settings.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/mobile_wallet.feature.settings.generated.resources/"

internal val Res.drawable.outline_logout: DrawableResource by lazy {
      DrawableResource("drawable:outline_logout", setOf(
        ResourceItem(setOf(), "${MD}drawable/outline_logout.xml", -1, -1),
      ))
    }

internal val Res.drawable.outline_password: DrawableResource by lazy {
      DrawableResource("drawable:outline_password", setOf(
        ResourceItem(setOf(), "${MD}drawable/outline_password.xml", -1, -1),
      ))
    }

internal val Res.drawable.outline_pin: DrawableResource by lazy {
      DrawableResource("drawable:outline_pin", setOf(
        ResourceItem(setOf(), "${MD}drawable/outline_pin.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("outline_logout", Res.drawable.outline_logout)
  map.put("outline_password", Res.drawable.outline_password)
  map.put("outline_pin", Res.drawable.outline_pin)
}
